import { useEffect } from "react";
import { FaTimes, FaExternalLinkAlt } from "react-icons/fa";

export default function MediaLightbox({ data, onClose }) {
  useEffect(() => {
    if (!data) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [data, onClose]);

  if (!data) return null;

  return (
    <div className="media-lightbox-backdrop" onClick={onClose}>
      <div className="media-lightbox" onClick={(e) => e.stopPropagation()}>
        <div className="media-lightbox-header">
          <span>{data.label}</span>
          <div className="media-lightbox-actions">
            <button
              className="media-lightbox-newtab"
              onClick={() => window.open(data.src, "_blank", "noopener,noreferrer")}
              title="Open in new tab"
            >
              <FaExternalLinkAlt /> Open in new tab
            </button>
            <button className="media-lightbox-close" onClick={onClose} title="Close">
              <FaTimes />
            </button>
          </div>
        </div>
        <div className="media-lightbox-body">
          <img src={data.src} alt={data.label} />
        </div>
      </div>
    </div>
  );
}